import { animate, state, style, transition, trigger } from '@angular/animations';

import { Component, input, model, signal } from '@angular/core';
import { FikoYTKokBilesenComponent } from '../../../../kok-bilesen/kok-bilesen.component';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';


@Component({
  selector: 'fikoyt-yuvarlak-resim',
  standalone: true,
  imports: [NzWaveModule],
  templateUrl: "./fikoyt-yuvarlak-resim.component.html",
  // styleUrl: "./fikoyt-uygulama-baslik.component.scss",
  animations: [
    trigger('imageChange', [
      state(
        'hidden',
        style({
          opacity: 0,
        })
      ),
      state(
        'visible',
        style({
          opacity: 1,
        })
      ),
      transition('hidden => visible', [animate('500ms ease-in')]),
      transition('visible => hidden', [animate('500ms ease-out')]),
    ]),
  ],
})
export class FikoYTYuvarlakResimComponent extends FikoYTKokBilesenComponent {

  image = model<File | string | null>(null);
  imageUrl = model<File | null>(null);
  size = input<number>(128);
  borderSize = input<number>(20);
  borderColor = input<string>("#1976d2");
  backgroundColor = input<string>("#f0f0f0");

  isImageVisible = model<boolean>(false);
  themeService = {
    backgroundColor: '#F0F0F0', // Buraya tema renginizi tanımlayın
  };


  constructor() {
    super();
  }

  // Avatar tıklandığında resim seçimi
  async onAvatarClick(): Promise<void> {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*'; // Sadece resim dosyalarını kabul et
    fileInput.click();

    fileInput.onchange = async () => {
      const file = fileInput.files?.[0];
      if (file) {
        this.changeImage(file);
      }
    };

    // try {
    //   if ('showOpenFilePicker' in window) {
    //     const [fileHandle] = await (window as any).showOpenFilePicker({
    //       types: [
    //         {
    //           description: 'Images',
    //           accept: {
    //             'image/*': ['.webp', '.webp', '.webp', '.gif', '.webp'],
    //           },
    //         },
    //       ],
    //       multiple: false,
    //     });
    //     const file = await fileHandle.getFile();
    //     this.changeImage(file);
    //   } else {
    //     alert('Tarayıcınız bu özelliği desteklemiyor.');
    //   }
    // } catch (error) {
    //   console.error('Dosya seçimi iptal edildi veya hata oluştu:', error);
    // }
  }


  private changeImage(file: File): void {
    this.isImageVisible.set(this.image() ? false : true); // Önce resmi görünmez yap
    this.CD.detectChanges();
    const reader = new FileReader();
    reader.onload = (e: any) => {
      setTimeout(() => {
        this.image.set(e.target.result); // Resmi değiştir
        this.imageUrl.set(file);
        this.isImageVisible.set(true); // Yeni resmi görünür yap
        this.CD.detectChanges();
      }, 500); // Görünmez olduktan sonra resmi değiştir
    };
    reader.readAsDataURL(file);
  }

  resimSil(): void {
    this.isImageVisible.set(false); // Önce resmi görünmez yap
    this.imageUrl.set(null);
    this.CD.detectChanges();
    setTimeout(() => {
      this.image.set(null); // Resmi değiştir
      this.imageUrl.set(null);
      this.isImageVisible.set(false); // Yeni resmi görünür yap
      this.CD.detectChanges();
    }, 500); // Görünmez olduktan sonra resmi değiştir


  }
}
